import React from "react";

/**
 * Flush progress strip: answered / total as a bar, no numeric label.
 *
 * @param {Object} props
 * @param {number} [props.answered]
 * @param {number} [props.total]
 * @returns {JSX.Element}
 */
export default function SurveyProgress({ answered = 0, total = 0 }) {
  const percent = total > 0 ? Math.round((answered / total) * 100) : 0;
  return (
    <div
      className="h-1 w-full bg-transparent"
      role="progressbar"
      aria-label="Survey progress"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={percent}
    >
      <div
        className="h-full bg-accent transition-[width] duration-200"
        style={{ width: `${percent}%` }}
      />
    </div>
  );
}
